const ROOT_DOMAIN = "cohesive.ai";

/**
 * `Domain` for the Auth0 SPA `is.authenticated` marker cookie. That cookie is
 * what gates silent SSO: `checkSession()` returns without touching the network
 * when it isn't readable on the current origin, so sharing it across `app.`,
 * `file.`, and `share.` is what lets the public shells pick up an app session.
 *
 * Undefined off `cohesive.ai`. A browser drops any cookie whose `Domain` isn't
 * a suffix of the host, so hardcoding the value disables SSO on localhost —
 * where the marker is instead host-scoped and already shared, since cookies
 * ignore port.
 */
export function authCookieDomain(
  hostname: string = window.location.hostname,
): string | undefined {
  if (hostname === ROOT_DOMAIN || hostname.endsWith(`.${ROOT_DOMAIN}`)) {
    return `.${ROOT_DOMAIN}`;
  }
  return undefined;
}
